import { render, staticRenderFns } from "./sessions-drawer.vue?vue&type=template&id=5c573b07&"
import script from "./sessions-drawer.vue?vue&type=script&lang=js&"
export * from "./sessions-drawer.vue?vue&type=script&lang=js&"
import style0 from "./sessions-drawer.vue?vue&type=style&index=0&id=5c573b07&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports